import useGoogleAnalytics from './useGoogleAnalytics'
import type { GaSearchItem } from './types'

export { useGoogleAnalytics, type GaSearchItem }
export * from './types'
